export { HorizontalSeparator, VerticalSeparator } from './Separator';
export type { SeparatorProps, SeparatorMargin } from './Separator';
